import { TextBold, TextRegular } from '@components/typography';
import styles from './styles.module.css';
import { Box, Checkbox, Flex } from '@chakra-ui/react';
import ButtonOutline from '@components/buttons/buttonOutline';
import { useMainState } from '@pages/AuditTrailSellOut/state/state';
import { find, isEmpty, reject, upperFirst } from 'lodash';
import { ChevronDownIcon } from '@assets/icons/index';
import { ConditionalComponent } from '@components/functionComponent';
import FloatingList from '@components/floatingList';
import { useState } from 'react';
import moment from 'moment';

const ActionButton = ({ values }) => {
    const { onChangeMainState } = useMainState();

    const onClickDetail = (event) => {
        event.stopPropagation();
        onChangeMainState({ selectedAuditTrail: values, isOpenDetailModal: true });
    };

    return (
        <ButtonOutline
            onClick={onClickDetail}
            className={styles['detail__button']}
            color={'var(--color-primary)'}
            component={<TextBold color="var(--color-primary)">Detail</TextBold>}
        />
    );
};

const ExportCheckbox = ({ values }) => {
    const { selectedExportAuditTrail, onChangeMainState } = useMainState();

    const isChecked = find(selectedExportAuditTrail, { id: values?.id });

    const handleClick = (e) => {
        e.stopPropagation();
        if (e.target !== e.currentTarget) {
            return;
        }

        let arr = [...selectedExportAuditTrail];
        const isExistSelectedAuditTrail = find(selectedExportAuditTrail, { id: values?.id });

        if (isExistSelectedAuditTrail) arr = reject(arr, { id: values?.id });
        else arr.push(values);

        onChangeMainState({
            selectedExportAuditTrail: arr,
        });
    };

    return (
        <Flex className={styles['column__container']} onClick={handleClick}>
            <Checkbox isChecked={!isEmpty(isChecked)} />
        </Flex>
    );
};

export const DateSellout = ({ value }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <Box className="date-sellout-column__audit-trail">
            <Flex
                className={styles['column__container']}
                gap="4px"
                onClick={(event) => {
                    event.stopPropagation();
                    setIsOpen(true);
                }}
            >
                <TextRegular className={styles['column__text']}>
                    {value?.[0] ? moment(value[0]).format('DD MMM YYYY') : '-'}
                </TextRegular>
                <ConditionalComponent statement={value?.length > 1}>
                    <ChevronDownIcon />
                </ConditionalComponent>
            </Flex>

            <ConditionalComponent statement={isOpen}>
                <FloatingList
                    arr={value}
                    renderElement={(item, idx) => (
                        <TextRegular className="date-item">{`${moment(item).format('DD MMM YYYY')}`}</TextRegular>
                    )}
                    onClose={() => setIsOpen(false)}
                />
            </ConditionalComponent>
        </Box>
    );
};

export const tableList = [
    {
        name: '',
        value: '',
        justifyContent: 'flex-start',
        width: 40,
        isCheckbox: true,
        component: ({ values }) => <ExportCheckbox values={values} />,
    },
    {
        name: 'Customer ID',
        value: 'customer_id',
        justifyContent: 'flex-start',
        withSort: true,
        component: ({ value }) => (
            <Flex className={styles['column__container']}>
                <TextRegular className={styles['column__text']}>{value ?? '-'}</TextRegular>
            </Flex>
        ),
    },
    {
        name: 'Customer',
        value: 'nama_outlet',
        justifyContent: 'flex-start',
        withSort: true,
        component: ({ value }) => (
            <Flex className={styles['column__container']}>
                <TextRegular className={styles['column__text']}>{value ?? '-'}</TextRegular>
            </Flex>
        ),
    },
    {
        name: 'DC',
        value: 'nama_dc',
        justifyContent: 'flex-start',
        withSort: true,
        component: ({ value }) => (
            <Flex className={styles['column__container']}>
                <TextRegular className={styles['column__text']}>{value ?? '-'}</TextRegular>
            </Flex>
        ),
    },
    {
        name: 'Store Group',
        value: 'group',
        justifyContent: 'flex-start',
        withSort: true,
        component: ({ value }) => (
            <Flex className={styles['column__container']}>
                <TextRegular className={styles['column__text']}>{value ?? '-'}</TextRegular>
            </Flex>
        ),
    },
    {
        name: 'Sellout Date',
        value: 'date_sellout',
        justifyContent: 'flex-start',
        withSort: true,
        component: ({ value }) => <DateSellout value={value} />,
    },
    {
        name: 'Timestamp',
        value: 'date_uploaded',
        justifyContent: 'flex-start',
        withSort: true,
        component: ({ value }) => (
            <Flex className={styles['column__container']}>
                <TextRegular className={styles['column__text']}>{value ?? '-'}</TextRegular>
            </Flex>
        ),
    },
    {
        name: 'Status',
        value: 'status',
        width: 125,
        justifyContent: 'flex-start',
        withSort: true,
        component: ({ value }) => {
            let textColor;
            let bgColor;

            switch (value) {
                case 'success':
                    textColor = 'var(--color-success80)';
                    bgColor = 'var(--color-success10)';
                    break;
                case 'pending':
                    textColor = 'var(--color-warning80)';
                    bgColor = 'var(--color-warning10)';
                    break;
                case 'processing':
                    textColor = 'var(--color-info80)';
                    bgColor = 'var(--color-info10)';
                    break;
                default:
                    textColor = 'var(--color-danger80)';
                    bgColor = 'var(--color-danger10)';
            }

            return (
                <Flex className={styles['column__container']}>
                    <TextRegular p="4px 6px" color={textColor} bg={bgColor} className={styles['column__text']}>
                        {upperFirst(value) ?? '-'}
                    </TextRegular>
                </Flex>
            );
        },
    },
    {
        name: 'Action',
        width: 100,
        justifyContent: 'flex-start',
        component: ({ values }) => <ActionButton values={values} />,
    },
];
